import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import HomeIcon from '@mui/icons-material/Home';
import {
  Box,
  Button,
  Container,
  Divider,
  Paper,
  Stack,
  Typography
} from '@mui/material';
import {
  useLocation,
  useNavigate
} from 'react-router-dom';

function PageNotFound() {
  const location = useLocation();
  const navigate = useNavigate();

  // 解析URL参数
  const searchParams = new URLSearchParams(location.search);
  const params: { [key: string]: string } = {};
  for (const [key, value] of searchParams.entries()) {
    params[key] = value;
  }

  return (
    <Container maxWidth="md" sx={{ 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center', 
      justifyContent: 'center', 
      minHeight: '100vh',
      textAlign: 'center'
    }}>
      <Paper 
        elevation={3} 
        sx={{ 
          p: 4, 
          borderRadius: 2,
          width: '100%',
          maxWidth: 500 
        }}
      >
        <ErrorOutlineIcon 
          sx={{ 
            fontSize: 80, 
            color: 'error.main',
            mb: 2 
          }} 
        />
        
        <Typography variant="h4" gutterBottom>
          Page Not Found
        </Typography>
        
        <Typography variant="subtitle1" color="text.secondary" gutterBottom>
          The page you are looking for does not exist.
        </Typography>
        
        <Divider sx={{ my: 2 }} />
        
        <Stack spacing={2}>
          <Box>
            <Typography variant="h6">Request Details</Typography>
            <Typography variant="body2" color="text.secondary">
              Path: {location.pathname}
            </Typography>
          </Box>
          
          {Object.keys(params).length > 0 && (
            <Box>
              <Typography variant="h6">URL Parameters</Typography>
              {Object.entries(params).map(([key, value]) => (
                <Typography 
                  key={key} 
                  variant="body2" 
                  color="text.secondary"
                >
                  {key}: {value}
                </Typography>
              ))}
            </Box>
          )}
        </Stack>
        
        <Divider sx={{ my: 2 }} />
        
        <Button
          variant="contained"
          color="primary"
          startIcon={<HomeIcon />}
          onClick={() => navigate('/')}
          sx={{ mt: 2 }}
        >
          返回首页
        </Button>
      </Paper>
    </Container>
  );
}

export default PageNotFound;